import { render } from "./OfficialMessages.vue?vue&type=template&id=6eef4c9c"
import script from "./OfficialMessages.vue?vue&type=script&lang=js"
export * from "./OfficialMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__